/**
 * Determines whether the user has privileges to create or update vehicles.
 *
 * @param  {object} userinfo   - The userinfo object from the `userinfo` model.
 * @param  {string} domainName - The users domain from the `domain` model.
 * @return {boolean}
 */
export const userCanManageVehicles = (userinfo, domainName) => {
  return userinfo.permissions.has(`*@urn:vimcar:${domainName}:vehicle/*`)
}

export const userCanManageUsers = (userinfo, domainName) => {
  return userinfo.permissions.has(`*@urn:vimcar:${domainName}:user/*`)
}

export const userCanAccessFleet = (userinfo, domainName) => {
  return (
    userCanManageVehicles(userinfo, domainName) ||
    userCanManageUsers(userinfo, domainName)
  )
}
